import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const getResourceDictionaryFromFoiList = async (apiToken = null, connectionId = null, foiList = null, foiOfFocus = null) => {
    if (!foiList) {
        console.log("no foiList");
        return null;
    }
    if (foiList.length === 0) {
        console.log("empty foiList");
        return null;
    }
    //console.log("CALLING SERVER with getresourcedictionaryfromfoilistwithoutrecursion")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'getresourcedictionaryfromfoilistwithoutrecursion',
            'apiToken': apiToken,
            'connectionId': connectionId, //For WebSocket alerts in case a resource changes, the user will later get an alert
            'foiList': foiList,
            'foiOfFocus': foiOfFocus    //For WebSocket alerts, This will be re-varified on the server that the user is allowed to view this
        },
    }).then((resp) => {
        if (resp?.data) {
            //resp.data is { "success": true, "resourceDictionary": resourceDictionary }
            // resourceDictionary is object with key=FOI and value=reourceJson
            //console.log("Successful RESPONSE from getresourcedictionaryfromfoilistwithoutrecursion call");
            return resp.data;
        }
        console.log("NO RESPONSE from getresourcedictionaryfromfoilistwithoutrecursion call");
    }).catch((error) => { console.log(error); });
}

export default getResourceDictionaryFromFoiList;